import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.96 5.56c.176 0 .343-.07.467-.193l.474-.474a.668.668 0 1 0-.94-.94l-.44.474a.667.667 0 0 0 .44 1.133M8.189 4a.667.667 0 0 0 .666-.667v-.666a.667.667 0 0 0-1.333 0v.666A.667.667 0 0 0 8.188 4M2.854 8h-.666a.667.667 0 0 0 0 1.333h.666a.667.667 0 1 0 0-1.333m1.094-2.633a.667.667 0 0 0 1.133-.47.67.67 0 0 0-.193-.47l-.474-.474a.667.667 0 0 0-.94.94zM14.188 8h-.667a.667.667 0 1 0 0 1.333h.666a.666.666 0 1 0 0-1.333M7.52 12.667h-2a.667.667 0 1 0 0 1.333h2a.666.666 0 1 0 0-1.333M12.188 10H11.6a3.667 3.667 0 1 0-6.827 0h-.586a.666.666 0 1 0 0 1.333h8a.667.667 0 1 0 0-1.333m-2.1 0h-3.8a2.3 2.3 0 0 1-.434-1.333 2.333 2.333 0 1 1 4.667 0A2.3 2.3 0 0 1 10.087 10m.766 2.667h-.666a.667.667 0 1 0 0 1.333h.666a.666.666 0 1 0 0-1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })